// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--3urga","container":"Footer-module--container--3pYK2"};